import { Component, OnInit } from "@angular/core";
import { AdminDataProvider } from "../../shared/providers/master-provider/admin-data.provider";
import { RewardProvider } from '../../shared/providers/rewards.provider';

@Component({
  selector: 'app-reward-history',
  templateUrl: './reward-history.component.html',
  styleUrls: ['./reward-history.component.scss']
})

export class RewardHistoryComponent implements OnInit {
  rewards = [];


  constructor(
    public rewardDataProvider: RewardProvider,
    public adminDataProvider: AdminDataProvider,
  ) { }

  ngOnInit() { }



  ngDoCheck() {
    this.rewards = this.rewardDataProvider.rewardHistory;

  }

}
